import svgIcon from '@/components/SvgIcon.vue'
import 'virtual:svg-icons-register' //添加注入脚本
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.component('svg-icon', svgIcon)
})
